import {IMuWidget} from "./IMuWidget";

export class TreeSelector extends IMuWidget {
	public items : TreeSelectorItem[] = [];
	// public itemsById : Record<string, TreeItem> = {};
	private value: string|null = null;

	public inModal: boolean = false;

	public nullTitle: string = "Není vybráno";

	public unknownTitle: string = "Neznámá položka";

	public searchCallback: ((term: string, resolve: (data: TreeItemSrcData[]) => void) => void)|null = null;

	private _disabled: boolean = false;
	private useModalClass: boolean = true;

	public afterItemRender: ((item: TreeSelectorItem)=>void)|null = null;

	public setDisabled(val: boolean) {
		this._disabled = val;
		this.container.classList.toggle('tree-selector__disabled', val);
	}

	public getDisabled(): boolean {
		return this._disabled;
	}

	public beforeIndex() {
		this.container.innerHTML =
			(this.inModal ? '<div class="tree-selector--value" mu-id="value"></div><div class="' + (this.useModalClass ? 'modal-b' : '') + '" mu-id="modal" style="display: none"><div class="' + (this.useModalClass ? 'modal-i' : '') + '">' : '') +
			'<div class="tree-selector--search"><span>Hledat</span><input type="search" mu-id="searchText" />' +
			'<span mu-id="bSearchClear" class="icon-erase icon-24 cursor-pointer"></span>' +
			(this.inModal ? '<span class="icon-close icon-24 cursor-pointer" mu-id="bCloseModal"></span>' : '') +
			'</div><div class="tree-selector--list" mu-id="list" tabindex="0">' +
			'<div class="tree-selector--item" mu-template="item" mu-widget="TreeSelectorItem">' +
			'<span class="tree-selector--item--collapse-button" mu-id="bCollapse"></span> ' +
			'<span class="tree-selector--item--title" mu-id="title"></span>' +
			'</div></div>' +
			(this.inModal ? '<div class="buttons"><span class="btn btn-default" mu-id="bSelectNull">Zrušit výběr</span></div></div></div>' : '')
		this.muRegisterEvent("change");
		(this.container as HTMLElement).className = "tree-selector";
		// this.container.tabIndex = 0;
	}

	afterIndex() {
		this.setSelected(this.value);
	}

	value_click() {
		if (!this._disabled) {
			this.openModal();
			this.ui.searchText.focus();
		}
	}

	collapseFromLevel(level : number) {
		for(const item of this.items)
			item.setCollapsed(item.level >= level);
	}

	searchText_keypress() {
		const searchCallback = this.searchCallback;
		if (searchCallback) {
			this.lastKeyPress = new Date();
			setTimeout(() => {
				// console.count("keypress on timer");
				const term = (this.ui.searchText as HTMLInputElement).value.trim();
				if (term.length < this.minTermLength) return;
				const now = new Date();
				const diff = (now.getTime() - this.lastKeyPress.getTime()) / 1000;
				if (diff > this.searchAfterSec) {
					// console.count("loading");
					searchCallback(term, items => {
						this.bindTree(items);
						this.search(this.ui.searchText.value);
					});
					this.lastKeyPress = new Date();
				}
			}, (this.searchAfterSec + 0.1) * 1000)

		} else setTimeout(() => this.search(this.ui.searchText.value));
	}

	private lastKeyPress: Date;

	public searchAfterSec : number = 1;

	public minTermLength : number = 3;

	bSearchClear_click() {
		this.ui.searchText.value = "";
		this.searchText_keypress();
	}

	modal_click(ev: Event) {
		ev.stopPropagation();
	}

	list_keyup(ev) {
		let sp = true;
		switch (ev.code) {
			case "ArrowUp":
				this.move(-1);
				break;
			case "ArrowDown":
				this.move(1);
				break;
			case "ArrowRight":
				this.getItem()?.setCollapsed(false);
				break;
			case "ArrowLeft":
				this.getItem()?.setCollapsed(true);
				break;
			default:
				sp = false;
				break;
		}
		if (sp) ev.stopPropagation();
	}

	public bindTree(srcData : TreeItemSrcData[]) {
		this.ui.list.innerHTML = "";
		const rooItem = this.prepareData(srcData);
		const bindTreeNode = (item : TreeItemSrcData, level : number, parentWidget : TreeSelectorItem|null = null) => {
			if (parentWidget) parentWidget.children = [];
			for(let child of item.children) {
				const w = (this.muWidgetFromTemplate("item", "list", {...child, level: level}) as TreeSelectorItem);
				w.parent = parentWidget;
				w.update();
				if (parentWidget) parentWidget.children.push(w);
				this.items.push(w);
				// console.log(w.title);
				bindTreeNode(child, level + 1, w);
				if (this.afterItemRender) this.afterItemRender(w);
			}
		}
		bindTreeNode(rooItem, 0);
		this.setSelected(this.value, false);
	}

	private prepareData(srcData: TreeItemSrcData[]) : TreeItemSrcData {
		let itemsById : Record<string, TreeItemSrcData> = {};
		this.items = [];
		const indexById = (items : TreeItemSrcData[], parentId : string|null) => {
			items.map(item => {
				itemsById[item.id] = item;
				if (!("parentId" in item)) item.parentId = parentId;
				if ('children' in item) indexById(item.children, item.id);
			})
		}
		indexById(srcData, null);
		let rootItem : TreeItemSrcData = {
			id: null,
			title: ""
		}
		let itemsByParentId : Record<string, TreeItemSrcData[]> = {}
		for(let k in itemsById)
		{
			const item = itemsById[k];
			if (!(item.parentId in itemsByParentId)) itemsByParentId[item.parentId] = [];
			itemsByParentId[item.parentId].push(item);
		}
		const makeTreeNode = (item : TreeItemSrcData) => {
			item.children = [];
			if (item.id in itemsByParentId) for (let child of itemsByParentId[item.id]) {
				item.children.push(child);
				makeTreeNode(child);
			}
		}

		makeTreeNode(rootItem);

		return rootItem;
	}

	public setSelected(id: string, fireEvent: boolean = true) {
		let selectedItem = null;
		for(let item of this.items) {
			item.markSelected(item.id == id);
			if (item.id == id) selectedItem = item;
		}
		this.value = id;
		if (this.ui.value) {
			this.ui.value.innerText = id
				? selectedItem?.title ?? this.unknownTitle
				: this.nullTitle;
			this.ui.value.classList.toggle('tree-selector--value__empty', !selectedItem)
		}
		this.openModal(false);
		if (fireEvent) this.muDispatchEvent("change", id, selectedItem);
	}

	getValue() {
		return this.value;
	}

	private move(direction: number) {
		let p = this.getItemIndex();
		p += direction;
		while (p >= 0 && p < this.items.length) {
			if (this.items[p].isVisible()) {
				this.setSelected(this.items[p].id);
				break;
			}
			p += direction;
		}
	}

	private getItemIndex() {
		return this.items.findIndex(item => item.id == this.value);
	}

	private getItem() : TreeSelectorItem|null {
		return this.items.find(item => item.id == this.value);
	}

	public getSelectedItemRecursive(): TreeSelectorItem[] {
		let res : TreeSelectorItem[] = [];
		const startItem = this.getItem();
		const addSubItems = (item: TreeSelectorItem) => {
			for(const subItem of item.children) {
				res.push(subItem);
				addSubItems(subItem);
			}
		}
		if (startItem) {
			res.push(startItem);
			addSubItems(startItem);
		}

		return res;
	}

	private search(term: string) {
		const matchItems : TreeSelectorItem[] = [];
		if (term) {
			for(const item of this.items) {
				item.searchStatus = item.match(term) ? "match" : "no";
				if (item.searchStatus == "match") matchItems.push(item)
			}
			for (const item of matchItems) {
				let pItem = item.parent;
				while (pItem) {
					if (pItem.searchStatus === "no") pItem.searchStatus = "path";
					pItem = pItem.parent;
				}
			}
			for(const item of this.items) {
				item.update();
			}
		} else {
			for(const item of this.items) {
				item.searchStatus = null;
				item.hide(false);
				item.update(true);
			}
		}
	}

	public openModal(visible: boolean = true) {
		if (this.ui.modal) this.muVisible(visible, "modal");
	}

	bCloseModal_click(ev: Event) {
		this.openModal(false);
		// ev.stopPropagation();
	}

	bSelectNull_click() {
		this.setSelected(null);
	}

	muFetchData(): any {
		return this.value;
	}

	muBindData(srcData: any) {
		this.setSelected(srcData);
	}
}

export class TreeSelectorItem extends IMuWidget {
	public title : string;
	public id : string;
	public collapsed : boolean = false;
	public parent : TreeSelectorItem|null;
	public children : TreeSelectorItem[] = [];
	public searchStatus : null|"path"|"match"|"no";
	public level : number;
	public data: any;

	public match(term: string) : boolean {
		return (this.title.toLowerCase().includes(term.toLowerCase()))
	}

	public update(force: boolean = false) {
		this.ui.title.innerText = this.title;
		this.container.style.marginLeft = this.level + "em";
		if (this.searchStatus) {
			this.container.style.display = this.searchStatus === "no" ? "none" : null;
			this.container.classList.toggle("tree-selector--item__search-match")
			this.ui.bCollapse.className =
				"tree-selector--item--collapse-button tree-selector--item--collapse-button__search-" + this.searchStatus;
		} else {
			if (force) this.setCollapsed(this.collapsed, force);
			else this.updateCollapseIcon();
		}
	}

	public setCollapsed(collapsed : boolean, force : boolean = false) {
		if (this.collapsed != collapsed || force) {
			this.collapsed = collapsed;
			for(let child of this.children) child.hide(this.collapsed);
			this.updateCollapseIcon();
		}
	}

	public hide(hidden: boolean) {
		const isHidden = hidden;// || this.collapsed;
		//todo: class pro animaci
		this.container.style.display = isHidden ? "none" : null;
		for(let child of this.children) child.hide(isHidden);
	}

	private updateCollapseIcon() {
		this.ui.bCollapse.className = "tree-selector--item--collapse-button"
			+ (this.collapsed ? " tree-selector--item--collapse-button__collapsed" : "");
	}

	public bCollapse_click() {
		if (this.searchStatus == null) this.setCollapsed(!this.collapsed);
	}

	public title_click() {
		(this.muParent as unknown as TreeSelector).setSelected(this.id);
	}

	public markSelected(isSelected: boolean) {
		this.container.classList.toggle("tree-selector--item__selected", isSelected);
	}

	isVisible() : boolean {
		return this.container.style.display != "none";
	}
}

export type TreeItemSrcData = {
	title : string,
	id : string,
	parentId? : string|null,
	children? : TreeItemSrcData[],
	data? : any,
}

